import React from 'react';
import { Link } from 'react-router-dom';
import { useClientDebts } from '../hooks/useApi';

export default function ClientDebts() {
  const { data, isLoading } = useClientDebts();

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Borxhet e Klientëve</h1>
        <div className="text-right">
          <p className="text-gray-500">Total Borxh</p>
          <p className="text-3xl font-bold text-red-600">€{data?.total_debt?.toFixed(2)}</p>
        </div>
      </div>

      <div className="card">
        <div className="mb-4 p-4 bg-yellow-50 rounded-lg">
          <p className="text-yellow-800">
            ⚠️ <strong>{data?.count}</strong> klientë me borxh të papaguar
          </p>
        </div>

        {isLoading ? (
          <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Kodi</th>
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Emri</th>
                  <th className="text-left py-3 px-2 font-medium text-gray-500">Telefon</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Total Blerje</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Paguar</th>
                  <th className="text-right py-3 px-2 font-medium text-gray-500">Borxh</th>
                </tr>
              </thead>
              <tbody>
                {data?.clients?.map((client) => (
                  <tr key={client.id} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-2 font-medium">{client.code}</td>
                    <td className="py-3 px-2">
                      <Link to={`/clients/${client.id}`} className="text-primary-600 hover:underline">
                        {client.name}
                      </Link>
                    </td>
                    <td className="py-3 px-2 text-gray-500">{client.phone || '-'}</td>
                    <td className="py-3 px-2 text-right">€{client.total_tickets?.toFixed(2)}</td>
                    <td className="py-3 px-2 text-right text-green-600">€{client.total_paid?.toFixed(2)}</td>
                    <td className="py-3 px-2 text-right font-bold text-red-600">€{client.balance?.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-50 font-bold">
                  <td colSpan="5" className="py-3 px-2 text-right">TOTAL:</td>
                  <td className="py-3 px-2 text-right text-red-600">€{data?.total_debt?.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
